import { z } from 'zod';
export const currencyOptionsSchema = z.object({
    currency: z.string().describe('ISO 4217 currency code (e.g., USD, EUR, GBP)'),
});
export const currencyCellSchema = z.number();
//# sourceMappingURL=currency.js.map